module.exports = __webpack_public_path__ + "static/img/operateHuhui.4f7c257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateHuhui.png
// module id = kySJ
// module chunks = 1